import RemitanoLogo from "@/assets/icons/remitano-logo.png"
import RenecLogo from "@/assets/icons/renec-logo.png"
import useTrans from "@/hooks/useTrans"
import { Container, Stack, Typography } from "@mui/material"
import Image from "next/image"
import React from "react"

const TrustedByOurInvestors = () => {
  const trans = useTrans()

  return (
    <Container maxWidth='xl' className='py-6 sm:pt-10 sm:pb-20'>
      <Stack alignItems='center' gap={1}>
        <Typography className='text-neutral-1000 text-center font-montserrat text-2xl sm:text-[2.5rem] font-bold leading-tight'>
          <span>{trans.home.trusted_by_our_investors}</span>
        </Typography>
      </Stack>

      <Stack direction='row' alignItems='center' justifyContent='center' gap={5} className='mt-8'>
        <Image src={RenecLogo} alt='renec-logo' className='w-[160px] h-[41px]' />
        <Image src={RemitanoLogo} alt='remitano-logo' className='w-[160px] h-[41px]' />
      </Stack>
    </Container>
  )
}

export default TrustedByOurInvestors
